import React from 'react';
import { Check } from 'lucide-react';
interface ProductCardProps {
  emoji: string;
  title: string;
  price: string;
  features: string[];
  isFree?: boolean;
  colorClass: string;
}
export function ProductCard({
  emoji,
  title,
  price,
  features,
  isFree,
  colorClass
}: ProductCardProps) {
  return <div className={`bg-white rounded-3xl shadow-md overflow-hidden border-l-8 ${colorClass} flex flex-col h-full`} data-id="element-153">
      <div className="p-6 border-b border-gray-100 bg-cream/60" data-id="element-154">
        <div className="flex justify-between items-start mb-4" data-id="element-155">
          <div className="text-4xl bg-cream w-16 h-16 rounded-2xl shadow-sm flex items-center justify-center border border-gold/20" data-id="element-156">
            {emoji}
          </div>
          <div className="text-right" data-id="element-157">
            {isFree ? <div className="flex flex-col items-end" data-id="element-158">
                <span className="text-sm text-gray-400 line-through mb-1" data-id="element-159">
                  Valor: {price}
                </span>
                <span className="bg-teal text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-160">
                  GRATIS HOY
                </span>
              </div> : <span className="text-sm font-medium text-navy bg-cream px-3 py-1 rounded-full" data-id="element-161">
                Valor: {price}
              </span>}
          </div>
        </div>
        <h3 className="text-xl font-bold text-navy leading-tight" data-id="element-162">{title}</h3>
      </div>

      <div className="p-6 flex-grow" data-id="element-163">
        <ul className="space-y-3" data-id="element-164">
          {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-165">
              <Check className="w-5 h-5 text-teal flex-shrink-0 mt-0.5" data-id="element-166" />
              <span className="text-gray-700 text-sm leading-relaxed" data-id="element-167">
                {feature}
              </span>
            </li>)}
        </ul>
      </div>
    </div>;
}